import styled from 'styled-components';

const FormSectionContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
`;

export default FormSectionContainer;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/FormSectionContainer.jsx